import styled from 'styled-components';

import { DeprecatedGrid as Grid } from '@simplywallst/ui-core';
import InformationSolid from '@simplywallst/ui-core/icons/InformationSolid';

export const TooltipTextWrapper = styled(Grid)`
  max-width: 260px;

  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x3spacePx / 2}px;
`;

export const InformationIcon = styled(InformationSolid)`
  cursor: help;
  display: inline-block;
`;
